import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
const IntentReasoning = (props) => {
    const { personalized_recommend_intent_reasoning = '' } = props;
    return (
        <>
            <div>
                <GrtAiMarkdown
                    thinkText="正在理解需求"
                    thoughtText="已理解学习需求"
                    className="ai-markdown-box"
                    content={personalized_recommend_intent_reasoning}
                ></GrtAiMarkdown>
            </div>
        </>
    );
};
export default IntentReasoning;
